import { render, staticRenderFns } from "./customTableHeader.vue?vue&type=template&id=5a2f4a48&scoped=true"
import script from "./customTableHeader.vue?vue&type=script&lang=js"
export * from "./customTableHeader.vue?vue&type=script&lang=js"
import style0 from "./customTableHeader.vue?vue&type=style&index=0&id=5a2f4a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f4a48",
  null
  
)

export default component.exports